// Merger for the planner right-pane filter writes. Mirrors
// `@products/features/products-filters/lib/merge-search.ts` byte-for-
// byte except for the function name — intentionally parallel so the
// itineraries domain owns its namespaced writer and consumers can't
// accidentally import the un-namespaced /products helper. Keep the
// two in sync; if a third filter surface lands, lift `isEmptyValue`
// + a generic `mergeSearchParams` into `packages/shared`.
// Pass the previous URL search + the source* updates; empty strings,
// undefined, and empty arrays drop out so the URL stays clean.

export type SourceSearchUpdates = Record<string, unknown>;

const isEmptyValue = (v: unknown): boolean =>
  v === undefined ||
  v === '' ||
  (Array.isArray(v) && (v as unknown[]).length === 0);

export const mergeSourceSearch = (
  prev: SourceSearchUpdates,
  updates: SourceSearchUpdates
): SourceSearchUpdates => {
  const next: SourceSearchUpdates = { ...prev, ...updates };
  for (const k of Object.keys(next)) {
    if (isEmptyValue(next[k])) delete next[k];
  }
  return next;
};
